<template>
  <div class="room remote-history" v-loading="loading" ref="room">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="table-command">
      <span class="table-command-item-key dh-right">{{ bridgeName }}</span>
      <div class="table-command-item" v-if="adminRouteBridgeId">
        <span class="table-command-item-key">桥梁:</span>
        <el-select v-model="adminSelectedBridge" placeholder="请选择桥梁" class="table-command-item-value-long">
          <el-option v-for="item in adminBridgeList" :key="item.bridgeId" :label="item.bridgeName" :value="item.bridgeId"></el-option>
        </el-select>
      </div>
      <!-- <div class="table-command-item">
        <span class="table-command-item-key">报警类型:</span>
        <el-select v-model="selectedType" placeholder="请选择报警类型" class="table-command-item-value-long">
          <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div> -->
      <div class="table-command-item">
        <span class="table-command-item-key">起始日期:</span>
        <el-date-picker
          class="date-time table-command-item-value-long"
          v-model="selectedStartDate"
          type="date"
          placeholder="选择日期"
          :editable="false"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
        ></el-date-picker>
      </div>
      <div class="table-command-item">
        <span class="table-command-item-key">截止日期:</span>
        <el-date-picker
          class="date-time table-command-item-value-long"
          v-model="selectedEndDate"
          type="date"
          placeholder="选择日期"
          :editable="false"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
        ></el-date-picker>
      </div>
      <div class="table-command-item">
        <el-button type="primary" @click="selectTypeDialogVisible = true" class="select-type-button">{{ selectTypeDialogText }}</el-button>
      </div>
      <div class="table-command-item" v-if="!this.adminRouteBridgeId">
        <span class="table-command-item-key">设备组:</span>
        <el-select v-model="selectedStation" placeholder="请选择设备组" class="table-command-item-value-long">
          <el-option v-for="item in stationOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
      <div class="table-command-item" v-if="!this.adminRouteBridgeId">
        <span class="table-command-item-key">设备:</span>
        <el-select v-model="selectedDevice" placeholder="请选择设备" class="table-command-item-value-long">
          <el-option v-for="item in deviceOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
    </div>
    <el-table :data="rowList" style="width: 100%" :max-height="tableMaxHeight">
      <el-table-column align="center" label="序号" prop="index" width="50"></el-table-column>
      <el-table-column align="center" label="桥梁" prop="bridgeName" width="180" v-if="adminRouteBridgeId"></el-table-column>
      <el-table-column align="center" label="设备组" prop="stationName" width="150"></el-table-column>
      <el-table-column align="center" label="设备名" prop="deviceName" width="170"></el-table-column>
      <el-table-column align="center" label="报错时间" prop="StatisticsErrorDate" width="130"></el-table-column>
      <el-table-column align="center" label="报错类型" prop="ErrorReportTypeName" width="100"></el-table-column>
      <el-table-column align="center" label="报错内容" prop="Description" width="480"></el-table-column>
      <el-table-column align="center" label="报错状态" width="100">
        <template slot-scope="scope">
          <el-tag class="percentage-tag" effect="dark" :type="scope.row.ErrorReportStatusClass">{{ scope.row.ErrorReportStatusName }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="处理备注" prop="message"></el-table-column>
      <el-table-column align="center" label="操作" width="110">
        <template slot-scope="scope">
          <el-button
            class="table-button"
            size="small"
            type="primary"
            @click="triggerCloseError(scope.row.reportId)"
            v-if="scope.row.errorReportStatus === 'CREATED'"
            >处理报错</el-button
          >
          <el-button class="table-button" size="small" @click="triggerCloseError(scope.row.reportId)" v-if="scope.row.errorReportStatus !== 'CREATED'"
            >查看报错</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      :style="pageStyle"
      layout="prev, pager, next"
      :total="totalCount"
      :page-size="pageSize"
      @current-change="currentChange"
      :current-page.sync="currentPage"
      ref="page"
    ></el-pagination>
    <!-- 处置报警弹窗 -->
    <el-dialog title="处理报错" :visible.sync="closeErrorDialogVisible" width="30%" v-loading="closeErrorDialogLoading">
      <el-form :model="closeErrorModel" ref="closeErrorForm" :rules="closeErrorFormRules" label-width="80px">
        <el-form-item label="设备分组">
          <span>{{ closeErrorModel.stationName }}</span>
        </el-form-item>
        <el-form-item label="报错设备">
          <span>{{ closeErrorModel.deviceName }}</span>
        </el-form-item>
        <el-form-item label="报错类型">
          <span>{{ closeErrorModel.ErrorReportTypeName }}</span>
        </el-form-item>
        <el-form-item label="报错时间">
          <span>{{ closeErrorModel.StatisticsErrorDate }}</span>
        </el-form-item>
        <el-form-item label="报错内容">
          <span>{{ closeErrorModel.Description }}</span>
        </el-form-item>
        <el-form-item label="处理备注" prop="message">
          <el-input
            type="textarea"
            v-model="closeErrorModel.message"
            placeholder="请输入处理记录"
            :rows="5"
            resize="none"
            class="dialog-form-textarea"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeErrorDialogVisible = false">取 消</el-button>
        <el-button @click="submitUpdateComment()" v-if="closeErrorModel.errorReportStatus === 'CREATED'">更新备注</el-button>
        <el-button type="primary" @click="submitCloseError()" v-if="closeErrorModel.errorReportStatus === 'CREATED'">处理报错</el-button>
      </span>
    </el-dialog>
    <!-- 选择报警类型弹窗 -->
    <el-dialog title="选择报警类型" :visible.sync="selectTypeDialogVisible" width="20%">
      <div class="select-type-checkbox-group">
        <el-checkbox v-model="selectTypeDialogModel.OVER_LIMIT">数据超限</el-checkbox>
        <el-checkbox v-model="selectTypeDialogModel.NO_DATA">数据中断</el-checkbox>
        <el-checkbox v-model="selectTypeDialogModel.ALL_SAME_VALUE">值固定不变</el-checkbox>
        <el-checkbox v-model="selectTypeDialogModel.ALL_ZERO">值全为0</el-checkbox>
        <el-checkbox v-model="selectTypeDialogModel.MALFUNCTION_DEVICE">设备故障</el-checkbox>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="selectTypeDialogVisible = false">取 消</el-button>
        <el-button @click="selectTypeDialogSubmit()">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { dateTimeToString, newtonsoftJsonToDate } from "../tools/GeneralTool";

export default {
  name: "SimpleCurrentData",
  data() {
    return {
      timer: null,
      tableData: [],
      loading: false,
      initComplete: false,
      deviceComplete: true,
      shownewUser: false,
      checkUserId: "",
      totalCount: 1,
      currentPage: 1,
      pageSize: 10,
      bridgeId: "",
      bridgeName: "",
      bridgeTranslateDict: {},
      deviceTranslateDict: {},
      deviceNameReplaceList: ["状态", "(枚举)"],
      tableMaxHeight: 777,
      clientHeight: 0,
      pageStyle: {},
      paginationHeight: 70,
      firstIndex: 0,
      lastIndex: 0,
      historyScenarioCurrentGroupNameList: [],

      routeBridgeId: "",
      routeStationId: "",
      deviceIdDeviceNameDict: {},
      selectedDataType: "ALL",

      rowList: [],

      closeErrorDialogVisible: false,
      closeErrorDialogLoading: false,
      closeErrorModel: {
        reportId: "",
        stationName: "",
        deviceName: "",
        ErrorReportTypeName: "",
        StatisticsErrorDate: "",
        message: "",
        Description: "",
        errorReportStatus: "",
      },
      closeErrorFormRules: {
        message: [{ required: true, message: "请输入处理备注", trigger: "blur" }],
      },

      statusOptions: [
        { label: "全部", value: "" },
        { label: "待处理", value: "CREATED" },
        { label: "已处理", value: "CLOSED" },
      ],
      selectedType: "",
      typeOptions: [
        { label: "全部", value: "" },
        { label: "数据超限", value: "OVER_LIMIT" },
        { label: "数据中断", value: "NO_DATA" },
        { label: "值固定不变", value: "ALL_SAME_VALUE" },
        { label: "值全为0", value: "ALL_ZERO" },
        { label: "设备故障", value: "MALFUNCTION_DEVICE" },
      ],
      selectedStation: "",
      stationOptions: [{ label: "全部", value: "" }],
      selectedDevice: "",
      deviceOptions: [{ label: "全部", value: "" }],
      selectedEndDate: "",
      selectedStartDate: "",

      adminBridgeList: [],
      adminBridgeDict: [],
      adminSelectedBridge: "",

      selectTypeDialogVisible: false,
      selectTypeModel: {
        OVER_LIMIT: true,
        NO_DATA: false,
        ALL_SAME_VALUE: false,
        ALL_ZERO: false,
        MALFUNCTION_DEVICE: true,
      },
      selectTypeDialogModel: {
        OVER_LIMIT: true,
        NO_DATA: false,
        ALL_SAME_VALUE: false,
        ALL_ZERO: false,
        MALFUNCTION_DEVICE: true,
      },
    };
  },
  computed: {
    selectTypeDialogText() {
      let selectedTypeCount = 0;
      for (let typeItem in this.selectTypeDialogModel) {
        let typeSelected = this.selectTypeDialogModel[typeItem];
        if (typeSelected === true) {
          selectedTypeCount++;
        }
      }

      return "选择报警类型 (" + selectedTypeCount + ")";
    },
    adminRouteBridgeId() {
      return this.routeBridgeId === "admin";
    },
    tableSpanRowIndexDict() {
      let clientMissionIdRowIndexListDict = {};
      for (let i = 0; i < this.tableData.length; i++) {
        const mission = this.tableData[i];
        if (clientMissionIdRowIndexListDict[mission.clientMissionId] === undefined) {
          clientMissionIdRowIndexListDict[mission.clientMissionId] = [i];
        } else {
          clientMissionIdRowIndexListDict[mission.clientMissionId].push(i);
        }
      }

      let result = {};
      for (let clientMissionId in clientMissionIdRowIndexListDict) {
        let rowList = clientMissionIdRowIndexListDict[clientMissionId];
        result[Math.min.apply(null, rowList)] = rowList.length;
      }

      return result;
    },
    ...mapGetters({
      isAdmin: "getIsAdmin",
      bridgeList: "getBridgeList",
    }),
  },
  mounted() {
    this.loading = true;

    this.timer = setInterval(() => {
      this.getDataList();
    }, this.REFRESH_SECOND);

    window.onresize = () => {
      this.clientHeight = document.documentElement.clientHeight;
    };
    this.tableMaxHeight = this.$refs.room.offsetHeight - this.paginationHeight;
    this.pageStyle = {
      left: (this.$refs.room.clientWidth - this.$refs.page.$el.clientWidth) / 2 + "px",
    };

    let defaultStartDate = new Date();
    defaultStartDate.setMonth(defaultStartDate.getMonth() - 6);
    defaultStartDate.setDate(1);
    this.selectedStartDate =
      defaultStartDate.getFullYear() +
      "-" +
      String(defaultStartDate.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(defaultStartDate.getDate()).padStart(2, "0");

    this.initializeBridgeAndGetData();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  watch: {
    clientHeight(newVal, oldVal) {
      this.tableMaxHeight = this.$refs.room.offsetHeight - this.paginationHeight;
    },
    totalCount() {
      this.$nextTick().then(() => {
        this.pageStyle = {
          left: (this.$refs.room.clientWidth - this.$refs.page.$el.clientWidth) / 2 + "px",
        };
      });
    },
    $route(route) {
      if (this.$route.query.bridgeId !== this.routeBridgeId) {
        this.initializeBridgeAndGetData();
      }
    },
    adminSelectedBridge() {
      if (!this.adminRouteBridgeId) {
        return;
      }

      this.loading = true;
      this.currentPage = 1;
      this.getDataList();
    },
    selectedType() {
      this.loading = true;
      this.currentPage = 1;
      this.getDataList();
    },
    selectedEndDate() {
      this.loading = true;
      this.currentPage = 1;
      this.getDataList();
    },
    selectedStartDate() {
      this.loading = true;
      this.currentPage = 1;
      this.getDataList();
    },
    selectedStation() {
      this.initDeviceList();
    },
    selectedDevice() {
      this.loading = true;
      this.currentPage = 1;
      this.getDataList();
    },
    selectTypeModel: {
      handler() {
        this.loading = true;
        this.currentPage = 1;
        this.getDataList();
      },
      deep: true,
    },
  },
  methods: {
    initializeBridgeAndGetData() {
      this.loading = true;
      this.initComplete = false;
      this.routeBridgeId = undefined;
      this.bridgeName = undefined;

      this.routeStationId = this.$route.query.stationId;
      let routeBridgeId = this.$route.query.bridgeId;

      if (routeBridgeId === "admin" || routeBridgeId === "ADMIN") {
        if (this.isAdmin) {
          this.routeBridgeId = "admin";
        }
      } else {
        this.bridgeList.forEach((bridge) => {
          if (bridge.id === routeBridgeId) {
            this.routeBridgeId = routeBridgeId;
            //break
            return false;
          }
        });
      }

      if (!this.routeBridgeId) {
        this.$alert("无效的桥梁编号", {
          confirmButtonText: "确定",
          showClose: true,
          type: "error",
          callback: (action) => {
            // console.log('stop');
            // this.resultObjectList = [];
          },
        });

        return;
      }

      if (this.adminRouteBridgeId) {
        //admin page
        let adminBridgeList = [{ bridgeId: "", bridgeName: "全部" }];
        let adminBridgeDict = {};
        this.$http.get("/bridge/recordErrorBridgeList").then((res) => {
          for (let bridgeItem of res.data) {
            adminBridgeList.push({
              bridgeId: bridgeItem.bridgeId,
              bridgeName: bridgeItem.bridgeName,
            });

            adminBridgeDict[bridgeItem.bridgeId] = bridgeItem.bridgeName;
          }

          this.bridgeName = "全局模式";
          this.adminBridgeList = adminBridgeList;
          this.adminBridgeDict = adminBridgeDict;
          this.stationOptions = [{ label: "全部", value: "" }];
          this.selectedStation = "";
          this.selectedDevice = "";
          this.adminSelectedBridge = "";

          this.currentPage = 1;
          this.$nextTick(() => {
            this.initComplete = true;
            this.getDataList();
          });
        });
      } else {
        //bridge page
        this.$http.get("/bridge/bridgeinfo?bridgeId=" + this.routeBridgeId).then((res) => {
          this.bridgeName = res.data.bridgeName;

          let stationList = [{ label: "全部", value: "" }];
          let setSelectedStation = "";
          res.data.stationList.forEach((stationItem) => {
            stationList.push({
              label: stationItem.stationName,
              value: stationItem.stationId,
            });

            if (this.routeStationId && this.routeStationId !== "" && this.routeStationId === stationItem.stationId) {
              setSelectedStation = this.routeStationId;
            }
          });
          this.stationOptions = stationList;
          this.selectedStation = setSelectedStation;
          if (this.selectedStation !== "") {
            this.initDeviceList();
          }
          this.selectedDevice = "";

          this.currentPage = 1;
          this.$nextTick(() => {
            this.initComplete = true;
            this.getDataList();
          });
        });
      }
    },
    initDeviceList() {
      this.loading = true;
      this.deviceComplete = false;
      let deviceOptions = [{ label: "全部", value: "" }];
      if (this.selectedStation === "") {
        deviceOptions.push({
          label: "请先选择设备组",
          value: "NA",
          disabled: true,
        });

        this.finishDeviceList(deviceOptions);
      } else {
        this.$http.get("/bridge/StationInfo?stationId=" + this.selectedStation).then((res) => {
          for (let deviceItem of res.data.deviceList) {
            deviceOptions.push({
              label: deviceItem.deviceName,
              value: deviceItem.deviceId,
            });
          }

          this.finishDeviceList(deviceOptions);
        });
      }
    },
    finishDeviceList(deviceOptions) {
      this.deviceOptions = deviceOptions;
      this.selectedDevice = "";
      this.currentPage = 1;
      this.$nextTick(() => {
        this.deviceComplete = true;
        this.getDataList();
      });
    },
    selectTypeDialogSubmit() {
      let foundSelectedType = false;
      for (let typeItem in this.selectTypeDialogModel) {
        let typeValue = this.selectTypeDialogModel[typeItem];
        if (typeValue === true) {
          foundSelectedType = true;
          break;
        }
      }

      if (!foundSelectedType) {
        this.$alert("至少选择一个报警类型", {
          confirmButtonText: "确定",
          showClose: true,
          type: "error",
          callback: (action) => {
            // console.log('stop');
            // this.resultObjectList = [];
          },
        });
        return;
      }

      this.selectTypeModel = JSON.parse(JSON.stringify(this.selectTypeDialogModel));
      this.selectTypeDialogVisible = false;
    },
    triggerCloseError(reportId) {
      let report = undefined;
      for (let dataItem of this.rowList) {
        if (dataItem.reportId === reportId) {
          report = dataItem;
          break;
        }
      }

      if (!report) {
        this.$alert("无法找到目标记录", {
          confirmButtonText: "确定",
          showClose: true,
          type: "error",
          callback: (action) => {
            // console.log('stop');
            // this.resultObjectList = [];
          },
        });
        return;
      }

      this.closeErrorModel.reportId = reportId;
      this.closeErrorModel.stationName = report.stationName;
      this.closeErrorModel.deviceName = report.deviceName;
      this.closeErrorModel.ErrorReportTypeName = report.ErrorReportTypeName;
      this.closeErrorModel.StatisticsErrorDate = report.StatisticsErrorDate;
      this.closeErrorModel.message = report.message;
      this.closeErrorModel.Description = report.Description;
      this.closeErrorModel.errorReportStatus = report.errorReportStatus;

      this.closeErrorDialogVisible = true;
    },
    submitCloseError() {
      if (this.closeErrorDialogVisible === false) {
        return;
      }

      this.$refs.closeErrorForm.validate().then(() => {
        this.closeErrorDialogLoading = true;
        let postBody = {
          reportIdList: [this.closeErrorModel.reportId],
          message: this.closeErrorModel.message,
        };

        this.$http
          .post("/dataError/CloseDataErrorReportForWebpage", postBody)
          .then(() => {
            this.closeErrorDialogLoading = false;
            this.closeErrorDialogVisible = false;
            this.getDataList();
            this.$message({ message: "处理成功", type: "success" });
          })
          .catch(() => {
            this.closeErrorDialogLoading = false;
          });
      });
    },

    submitUpdateComment() {
      if (this.closeErrorDialogVisible === false) {
        return;
      }

      this.$refs.closeErrorForm.validate().then(() => {
        this.closeErrorDialogLoading = true;
        let postBody = {
          reportIdList: [this.closeErrorModel.reportId],
          message: this.closeErrorModel.message,
        };

        this.$http
          .post("/dataError/UpdateDataErrorReportMessageForWebpage", postBody)
          .then(() => {
            this.closeErrorDialogLoading = false;
            this.closeErrorDialogVisible = false;
            this.getDataList();
            this.$message({ message: "更新成功", type: "success" });
          })
          .catch(() => {
            this.closeErrorDialogLoading = false;
          });
      });
    },
    dataTypeOnChange() {
      this.currentChange(1);
    },

    refreshData() {
      this.loading = true;
      this.getDataList();
    },
    currentChange(index) {
      this.loading = true;
      this.currentPage = index;

      this.getDataList();

      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    getDataList() {
      if (this.initComplete === false) {
        return;
      }
      if (this.deviceComplete === false) {
        return;
      }

      this.loading = true;

      if (!this.routeBridgeId || !this.bridgeName) {
        this.$alert("无效的桥梁编号", {
          confirmButtonText: "确定",
          showClose: true,
          type: "error",
          callback: (action) => {
            // console.log('stop');
            // this.resultObjectList = [];
          },
        });

        return;
      }

      let endDate = this.selectedEndDate;
      if (endDate === null) {
        endDate = "";
      }
      let startDate = this.selectedStartDate;
      if (startDate === null) {
        startDate = "";
      }

      let queryBridgeId = this.routeBridgeId;
      if (this.adminRouteBridgeId) {
        queryBridgeId = this.adminSelectedBridge;
      }

      let typeUrl = "";
      for (let typeItem in this.selectTypeModel) {
        let typeValue = this.selectTypeModel[typeItem];
        if (typeValue === true) {
          typeUrl += "&typeList=" + typeItem;
        }
      }

      let countQuery = this.$http.get(
        "/dataError/GetDataErrorReportForWebpageCount?bridgeId=" +
          queryBridgeId +
          "&stationId=" +
          this.selectedStation +
          "&deviceId=" +
          this.selectedDevice +
          "&endDate=" +
          endDate +
          "&startDate=" +
          startDate +
          typeUrl
      );

      let dataQuery = this.$http.get(
        "/dataError/GetDataErrorReportForWebpageList?bridgeId=" +
          queryBridgeId +
          "&stationId=" +
          this.selectedStation +
          "&deviceId=" +
          this.selectedDevice +
          "&endDate=" +
          endDate +
          "&startDate=" +
          startDate +
          typeUrl +
          "&start=" +
          (this.currentPage - 1) * this.pageSize +
          "&limit=" +
          this.pageSize
      );

      this.$http.all([countQuery, dataQuery]).then(
        this.$http.spread((countRes, dataRes) => {
          this.totalCount = countRes.data.count;

          let itemIndex = this.pageSize * (this.currentPage - 1) + 1;

          for (let dataItem of dataRes.data) {
            dataItem.index = itemIndex;
            itemIndex++;

            if (dataItem.ErrorReportStatusName === "待处理") {
              dataItem.ErrorReportStatusClass = "warning";
            } else if (dataItem.ErrorReportStatusName === "已处理") {
              dataItem.ErrorReportStatusClass = "success";
            } else if (dataItem.ErrorReportStatusName === "已过期") {
              dataItem.ErrorReportStatusClass = "danger";
            }

            if (this.adminRouteBridgeId) {
              dataItem.bridgeName = dataItem.bridgeId;
              if (this.adminBridgeDict[dataItem.bridgeName]) {
                dataItem.bridgeName = this.adminBridgeDict[dataItem.bridgeName];
              }
            }
          }

          this.rowList = dataRes.data;

          setTimeout(() => {
            this.loading = false;
          }, 500);
        })
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.remote-history {
  margin-top: 20px;
  background-color: #fff;
  padding: 20px;
  // height: 784px !important;
  height: calc(100% - 50px) !important;
  position: relative;

  .table-command {
    display: flex;
    // justify-content: flex-end;
    margin-bottom: 20px;
  }

  .table-command-item-key {
    margin-right: 10px;
    margin-left: 20px;
    margin-top: 10px;
  }

  .table-command-item-value {
    width: 110px;
  }

  .table-command-item-value-long {
    width: 150px;
  }

  .pagination {
    position: absolute;
    bottom: 0;
  }
}

.status-tag {
  cursor: pointer;
}

.table-button {
  margin-bottom: 10px;
  margin-left: 10px;
}

.dialog-form-input {
  width: 80%;
}

.error-level-tag {
  min-width: 75px;
}

.select-type-checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.select-type-button {
  margin-left: 20px;
  height: 95%;
}

::v-deep .table-row-spliter {
  border-right: 1px solid #ebeff0;
}

::v-deep .el-pagination {
  text-align: center;
}
</style>
